// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2OmA0","calendarButtons":"ClockData_calendarButtons__1RndX"};